import { tv, type VariantProps } from 'tailwind-variants';

export type AtPlayButtonVariants = VariantProps<typeof atPlayButton>;

const atPlayButton = tv({
  base: 'group flex items-center justify-center rounded-xl focus:outline-none',
  variants: {
    background: {
      true: 'bg-skin-primary-inverted',
      false: 'bg-transparent',
    },
  },
});

export default atPlayButton;
